import CalculateIcon from '@mui/icons-material/Calculate';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Title } from 'react-admin';
import { Link } from 'react-router-dom';
import { DevToolsGate } from './DevToolsGate';

const TOOLS = [
  {
    to: '/dev-tools/recalculate',
    icon: <CalculateIcon fontSize="large" />,
    title: 'Recalculate',
    description: 'Run day-global-calculations for a user profile over a date range and inspect every plugin output.'
  }
];

const DevToolsHome = () => (
  <DevToolsGate>
    <Title title="Dev Tools" />
    <Typography variant="body2" color="text.secondary" sx={{ my: 2 }}>
      Developer utilities. Shared password — a speed bump, not access control. Access is enforced by superadmin account allow-listing on the server.
    </Typography>
    {TOOLS.map((tool) => (
      <Card key={tool.to} sx={{ maxWidth: 480, mb: 2 }}>
        <CardActionArea component={Link} to={tool.to}>
          <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {tool.icon}
            <div>
              <Typography variant="h6">{tool.title}</Typography>
              <Typography variant="body2" color="text.secondary">
                {tool.description}
              </Typography>
            </div>
          </CardContent>
        </CardActionArea>
      </Card>
    ))}
  </DevToolsGate>
);

export default DevToolsHome;
